export const RadioButtonWithLabelTestIds = {
    RadioButton: (testId)=>"".concat(testId, "-radio")
};
